define('shared/remote/payment/adyen/update/initSession',[
    'shared/remote/ajax',
    './constructSessionPayload'
], function (
    ajax,
    constructSessionPayload
) {
        return function () {
            return constructSessionPayload().then(function (sessionPayload) {
                return ajax({
                    url: '/services/commerce-v4/offermanager/UpdateTokenByStandaloneCapture',
                    method: 'post',
                    data: sessionPayload,
                });
            });
        };
    });

